import React, { FunctionComponent } from "react";
import classNames from "classnames";
import { Form, Checkbox } from "antd";
import FormLabel from "./FormLabel";
import styles from "../BiformLayout.module.scss";
import { QuestionComponentProps } from "../helper";

// CHECKBOX — pick one or more options.
const CheckboxComponent: FunctionComponent<QuestionComponentProps> = ({ question, disabled = false }) => (
  <Form.Item
    name={question.id}
    label={<FormLabel label={question.label} required={question.isRequired} description={question.description} />}
    rules={[{ required: question.isRequired, type: "array", message: "Please select at least one option!" }]}
    className={classNames(styles.checkboxInput, styles.disableCheckboxInput)}
  >
    <Checkbox.Group disabled={disabled}>
      {(question.options || []).map(option => (
        <Checkbox key={option.value} value={option.value}>
          {option.label}
        </Checkbox>
      ))}
    </Checkbox.Group>
  </Form.Item>
);

export default CheckboxComponent;
